(() => {
  'use strict';
  const turkish = document.documentElement.lang.toLowerCase().startsWith('tr');
  const setText = (selector, text) => document.querySelectorAll(selector).forEach(element => {
    if (element.textContent !== text) element.textContent = text;
  });
  const update = () => {
    document.querySelectorAll('product-card').forEach(card => {
      const figure = card.querySelector('.product-card__figure');
      const heart = card.querySelector('.st-wishlist-button[data-type="product-card"]');
      if (!figure || !heart) return;
      if (heart.parentElement !== figure) figure.append(heart);
      card.querySelectorAll('.fk-card-title-row').forEach(row => row.replaceWith(...row.childNodes));
    });
    if (!turkish) return;
    document.querySelectorAll('.st-wishlist-button').forEach(button => {
      const label = button.classList.contains('st-is-loading') ? 'Favoriler güncelleniyor' : button.classList.contains('st-is-added') ? 'Favorilerden çıkar' : 'Favorilere ekle';
      if (button.getAttribute('aria-label') !== label) button.setAttribute('aria-label', label);
      if (button.getAttribute('title') !== label) button.setAttribute('title', label);
      const pressed = String(button.classList.contains('st-is-added'));
      if (button.getAttribute('aria-pressed') !== pressed) button.setAttribute('aria-pressed', pressed);
    });
    document.querySelectorAll('.st-wishlist-details-button').forEach(button => {
      if (button.getAttribute('aria-label') !== 'Favori listemi aç') button.setAttribute('aria-label', 'Favori listemi aç');
      if (button.getAttribute('title') !== 'Favori listemi aç') button.setAttribute('title', 'Favori listemi aç');
    });
    setText('.st-wishlist-details_title .st-h3', 'Favori listem');
    setText('.st-wishlist-details_empty p:first-child b', 'Favorilerinizi burada biriktirin');
    setText('.st-wishlist-details_empty p:nth-child(2)', 'Beğendiğiniz ürünlerin kalbine dokunun; hepsi burada sizi beklesin.');
    setText('.st-wishlist-save-your-wishlist a', 'Favorilerinizi hesabınıza kaydetmek için giriş yapın');
  };
  let queued = false;
  new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; update(); });
  }).observe(document.body, {childList: true, subtree: true, attributes: true, attributeFilter: ['class']});
  update();
})();
